import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Mixpanel from 'mixpanel-browser';
import Button from '~/components/Button';
import QuizHeader from '~/components/QuizHeader';
import { NavigationPath, ScreenProps } from '~/core/dto/navigationDTO';
import Spacer from '~/components/Spacer';
import parentChart from '~/assets/illustrations/ParentChart.svg';

import './GrowthPlan.styles.css';
import { changeThemeColor } from '~/core/helpers/internal';

const GrowthPlan: FC<ScreenProps> = ( { type } ) => {

  const navigate = useNavigate();
  const routeName = `GrowthPlan-${type}`;

  const onContinue = () => {

    Mixpanel.track( routeName, { state: 1 } );

    navigate( NavigationPath.QuizResult );

  };

  useEffect( () => {

    Mixpanel.track( routeName, { state: 0 } );

    changeThemeColor( '#2A8E5C' );

    return () => changeThemeColor( '#F1E8DC' );

  }, [] );

  return (
    <div className="container growthPlanContainer">
      <QuizHeader onlyTitle type="parent" />
      <div className="scrollContainer smallContainer">
        <h1 className="textCenter">Your child’s growth plan is ready</h1>
        <Spacer size={12} />
        <p className="textCenter">
          If you invest&#160;
          <b>100 € / month</b>
          &#160;together, in 30 years you could have&#160;
          <b>233 000 €</b>
          .
        </p>
        <Spacer size={32} />
        <img src={parentChart} alt="" />
        <Spacer size={16} />
        <p className="textCenter">
          <span className="textUnderline">If you don&apos;t invest</span>
          &#160;it, it will be just&#160;
          <span className="primaryFlamingo">36 000 €</span>
        </p>
        <Spacer size={32} />
        <p className="info textCenter">*Based on historical data for the S&P 500 over the last 35 years.</p>
      </div>
      <Spacer size={16} />
      <Button className="growthPlanContinue smallContainer" onPress={onContinue}>Continue</Button>
      <Spacer size={16} />
    </div>
  );

};

export default GrowthPlan;
